<ng-container #sortDropdownItemContainer></ng-container>

<ng-template #defaultTemplate>
    <div #sortId class="sort-by-wrapper card" role="region" aria-label="Sort by">
        <div class="dropdown dropdown-sort-by card-header">

            <button type="button"
                id="sortByID"
                data-toggle="dropdown"
                aria-haspopup="true"
                [attr.aria-expanded]="arriaExpanded"
                attr.data-active-id="{{selectedSortRuleIndex}}"
                attr.aria-activedescendent="sortRule-{{selectedSortRuleIndex}}"
                data-qa="srt-ptns-dflt">

                <p class="sort-by-text">
                    <span class="float-left">Sort </span>
                    <span class="d-none d-lg-block float-left">&nbsp;({{activeSortRule ? activeSortRule.label : ''}})</span>
                    <span class="svg-icon svg-icon-sort-by-caret svg-icon-Arrow_down_black"></span>
                </p>
            </button>

            <ul class="dropdown-menu sort-dropdown__wrapper card-body dropdown-menu-sort-mobile" aria-labelledby="sortByID" role="menu">
                <li *ngFor="let sortRule of sortRules; let i = index" role="none">
                    <a [ngClass]="{'dropdown-item': true, 'filter-selected-link': activeSortRule && activeSortRule.label == sortRule.label}"
                    id="sortRule-{{i}}"
                    (click)="doSortEmitter(sortRule)"
                    href="#"
                    [attr.aria-current]="sortRule.selected ? true : null"
                    onClick="return false;" role="menuitem" tabindex="0" attr.aria-label="{{sortRule.label}}" data-qa="srt-ptns">{{sortRule.label}}</a>
                </li>
            </ul>
        </div>
    </div>
</ng-template>


<ng-template #themeBuilderEnabledTemplate>
    <div #sortId class="sort-ui dropdown dropdown-sort-by" role="region" aria-label="Sort by">
        <button type="button"
            id="sortByID"
            class="sort-ui__sort-btn"
            data-toggle="dropdown"
            aria-haspopup="true"
            [attr.aria-expanded]="arriaExpanded"
            attr.data-active-id="{{selectedSortRuleIndex}}"
            attr.aria-activedescendent="sortRule-{{selectedSortRuleIndex}}"
            data-qa="srt-ptns-dflt">

            <p class="sort-ui__text-container">
                <span class="sort-ui__default-text">Sort by </span>
                <span class="sort-ui__strategy d-none d-lg-inline-block">&nbsp;{{activeSortRule ? activeSortRule.label : ''}}</span>
                <span class="sort-ui__icon svg-caret-down"></span>
            </p>
        </button>

        <ul class="sort-ui__dropdown sort-dropdown__wrapper dropdown-menu dropdown-menu-sort-mobile" aria-labelledby="sortByID" role="menu">
            <li *ngFor="let sortRule of sortRules; let i = index" role="none" class="sort-ui__dropdown-item">
                <a [ngClass]="{'sort-ui__dropdown-anchor': true, 'dropdown-item': true, 'filter-selected-link': activeSortRule && activeSortRule.label == sortRule.label}"
                    id="sortRule-{{i}}"
                    (click)="doSortEmitter(sortRule)"
                    href="#"
                    [attr.aria-current]="sortRule.selected ? true : null"
                    onClick="return false;" role="menuitem" tabindex="0" attr.aria-label="{{sortRule.label}}"
                    data-qa="srt-ptns">{{sortRule.label}}</a>
            </li>
        </ul>
    </div>
</ng-template>


<ng-template #DSTV2Template>
    <div #sortId class="sort-by-wrapper">
        <div class="dropdown sort-dropdown" dropdown>

            <button type="button"
                class="btn btn-secondary sort-dropdown__btn"
                id="sortDropdown"
                role="button"
                aria-haspopup="true"
                [attr.aria-expanded]="arriaExpanded"
                attr.data-active-id="{{selectedSortRuleIndex}}"
                attr.aria-activedescendent="sortRule-{{selectedSortRuleIndex}}"
                data-qa="srt-ptns-dflt"
                dropdownToggle>
                <span class="float-left">Sort by </span>
                <span class="d-lg-block float-left">&nbsp;{{activeSortRule ? activeSortRule.label : ''}}</span>
            </button>
        
            <ul id="sortDropdownMenu" role="menu" class="dropdown-menu sort-dropdown__wrapper" aria-label="Sort" *dropdownMenu>
                <li role="none" *ngFor="let sortRule of sortRules; let i = index">
                    <a role="menuitem" tabindex="0" class="dropdown-item" (click)="doSortEmitter(sortRule)" 
                        id="sortRule-{{i}}"href="javascript:void(0);" attr.aria-label="{{sortRule.label}} " 
                            data-qa="srt-ptns">{{sortRule.label}}</a>
                </li>
            </ul>
        </div>
    </div>
</ng-template>